/**
 * Mai uno schermo nero muto: se l'avvio fallisce si mostra "Avvio non riuscito" con il messaggio d'errore e
 * "Riprovo tra 30 s", poi si riprova da soli.
 */
export const START_RETRY_MS = 30_000;

export interface BootRetryOptions {
  boot: () => Promise<void>;
  /** Mostra l'errore a schermo. */
  show: (message: string, retryInS: number) => void;
  sleep: (ms: number) => Promise<void>;
  retryMs?: number;
  /** Solo per i test: smette dopo N tentativi falliti. */
  maxAttempts?: number;
  log?: (e: unknown) => void;
}

/** Ritorna il numero di tentativi fatti (l'ultimo è quello riuscito, oppure `maxAttempts` se ha rinunciato). */
export async function bootWithRetry(o: BootRetryOptions): Promise<number> {
  const retryMs = o.retryMs ?? START_RETRY_MS;
  for (let attempt = 1; ; attempt++) {
    try {
      await o.boot();
      return attempt;
    } catch (e) {
      o.log?.(e);
      o.show(e instanceof Error ? `${e.name}: ${e.message}` : String(e), Math.round(retryMs / 1000));
      if (o.maxAttempts !== undefined && attempt >= o.maxAttempts) return attempt;
      await o.sleep(retryMs);
    }
  }
}

/** Schermata di emergenza in DOM puro (per errori prima che la UI esista): messaggio + ricarica dopo 30 s. */
export function showFatal(root: HTMLElement, message: string, retryInS = START_RETRY_MS / 1000): void {
  const box = document.createElement('div');
  box.style.cssText = 'position:absolute;inset:0;z-index:50;background:#000;color:#fff;display:flex;flex-direction:column;'
    + 'align-items:center;justify-content:center;text-align:center;padding:4vmin;box-sizing:border-box;'
    + 'font-family:system-ui,-apple-system,"Segoe UI",Roboto,Arial,sans-serif;';
  const title = document.createElement('div');
  title.style.cssText = 'font-size:9vmin;font-weight:700;margin-bottom:3vmin;';
  title.textContent = 'Avvio non riuscito';
  const msg = document.createElement('div');
  msg.style.cssText = 'font-size:3.2vmin;opacity:.85;max-width:90vw;word-break:break-word;margin-bottom:3vmin;';
  msg.textContent = message;
  const again = document.createElement('div');
  again.style.cssText = 'font-size:3.6vmin;opacity:.7;';
  again.textContent = `Riprovo tra ${retryInS} s`;
  box.append(title, msg, again);
  root.replaceChildren(box);
  setTimeout(() => window.location.reload(), retryInS * 1000);
}
